import { validateOfferCodeAction } from 'containers/App/actions';
import { PAYMENT_TERM_MONTHLY } from 'containers/IwaIllustrationPage/constants';

function asyncValidate(values, dispatch, props, fieldName) {
  if (fieldName !== undefined) {
    if (values.get('premium') !== '' && values.get('currency') !== 'Select') {
      if (values.get('offerCode') !== '') {
        let premiumVal = (values.get('premiumPaymentTerm') == PAYMENT_TERM_MONTHLY) ? values.get('singlePremiumAmount') : values.get('premium');
        return new Promise((resolve, reject) => {
          dispatch(
            validateOfferCodeAction({
              offerCode: values.get('offerCode'),
              productCode: props.product.PTVCode,
              productVersion: props.product.PTVVersion,
              currency: values.get('currency'),
              premium : premiumVal,
              premiumType: 'SinglePremium',
              resolve,
              reject,
            }),
          );
        });
      }
    }

    return new Promise(resolve => {
      dispatch(
        validateOfferCodeAction({
          offerCode: '',
          resolve,
        }),
      );
    });
  }

  if (props?.offerCodeData?.errorMessage) {
    return new Promise((resolve, reject) => {
      reject({
        offerCode: props?.offerCodeData?.errorMessage,
      });
    });
  } else {
    return new Promise(resolve => {
      resolve();
    });
  }
}

export default asyncValidate;
